import { render, staticRenderFns } from "./transactionAttachmentComponent.vue?vue&type=template&id=7c3de064&scoped=true&"
import script from "./transactionAttachmentComponent.vue?vue&type=script&lang=js&"
export * from "./transactionAttachmentComponent.vue?vue&type=script&lang=js&"
import style0 from "./transactionAttachmentComponent.vue?vue&type=style&index=0&id=7c3de064&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c3de064",
  null
  
)

export default component.exports